import styled from 'styled-components'
import Save from '../Buttons/Save'

const Confirm = styled(Save) `
    width: 206px;
    margin: 0;
`

export default Confirm